export default {"src":"/_next/static/media/searchIcon.6f0da1b0.svg","height":30,"width":30};